module.exports = __webpack_public_path__ + "img/YYFAX-FPD.710c374e.png";